// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 27962) return "js/home.js";
	if (chunkId === 43) return "js/change-password.js";
	if (chunkId === 35976) return "js/sso-login.js";
	if (chunkId === 42572) return "js/local-login.js";
	if (chunkId === 21055) return "js/ug-candidate-login.js";
	if (chunkId === 66331) return "js/ug-candidate-remita-confirm.js";
	if (chunkId === 88272) return "js/ug-applicant-remita-confirm.js";
	if (chunkId === 54999) return "js/candidate-enrollment.js";
	if (chunkId === 94625) return "js/admission-referee.js";
	if (chunkId === 60730) return "js/candidate-verification.js";
	if (chunkId === 50562) return "js/candidate-verification-complete.js";
	if (chunkId === 74151) return "js/candidate-activation.js";
	if (chunkId === 10814) return "js/below-cutoff-mark.js";
	if (chunkId === 83141) return "js/no-suggested-programme.js";
	if (chunkId === 95263) return "js/change-course.js";
	if (chunkId === 79348) return "js/candidate-activated.js";
	if (chunkId === 91193) return "js/unauthorized.js";
	if (chunkId === 93740) return "js/make-payment.js";
	if (chunkId === 66682) return "js/make-invoice-payment.js";
	if (chunkId === 87860) return "js/platinum-callback.js.js";
	if (chunkId === 69764) return "js/student-lectures.js";
	if (chunkId === 65832) return "js/student-profile.js";
	if (chunkId === 99613) return "js/course-materials.js";
	if (chunkId === 18470) return "js/rate-lecturer.js";
	if (chunkId === 25739) return "js/student-inspired.js";
	if (chunkId === 19671) return "js/student-course-reg.js";
	if (chunkId === 80708) return "js/student-siwes.js";
	if (chunkId === 9597) return "js/student-siwes-courses.js";
	if (chunkId === 28270) return "js/student-siwes-placement.js";
	if (chunkId === 19788) return "js/student-announcement.js";
	if (chunkId === 62901) return "js/student-results.js";
	if (chunkId === 9178) return "js/student-assignment.js";
	if (chunkId === 2628) return "js/student-fees-and-receipts.js";
	if (chunkId === 38662) return "js/student-fees.js";
	if (chunkId === 83534) return "js/supplementary-fees.js";
	if (chunkId === 52730) return "js/student-receipts.js";
	if (chunkId === 81330) return "js/bedspace-reservations.js";
	if (chunkId === 52579) return "js/available-hostels.js";
	if (chunkId === 26151) return "js/my-reservations.js";
	if (chunkId === 71729) return "js/student-assigment-info.js";
	if (chunkId === 70414) return "js/student-cbt.js";
	if (chunkId === 50846) return "js/student-cbt-overview.js";
	if (chunkId === 78549) return "js/student-test-attempt.js";
	if (chunkId === 5470) return "js/student-timetable.js";
	if (chunkId === 62574) return "js/student-settings.js";
	if (chunkId === 52188) return "js/course-home.js";
	if (chunkId === 91165) return "js/student-course-form.js";
	if (chunkId === 69527) return "js/student-extra-credit-applications.js";
	if (chunkId === 5422) return "js/add-and-drop.js";
	if (chunkId === 56027) return "js/transaction-validation.js";
	if (chunkId === 70400) return "js/convocation-fees.js";
	if (chunkId === 90671) return "js/clearance.js";
	if (chunkId === 12437) return "js/on-demand-clearance.js";
	if (chunkId === 30667) return "js/invoices.js";
	if (chunkId === 19459) return "js/student-elections.js";
	if (chunkId === 69832) return "js/student-elections-vote.js";
	if (chunkId === 70696) return "js/student-ticketing-vote.js";
	if (chunkId === 94756) return "js/lecturer-assignement.js";
	if (chunkId === 36224) return "js/lecturer-course-info.js";
	if (chunkId === 86155) return "js/add-assessment.js";
	if (chunkId === 97230) return "js/lecturer-course-synopsis.js";
	if (chunkId === 81471) return "js/lecturer-submitted-assignment.js";
	if (chunkId === 41018) return "js/lecturer-courses.js";
	if (chunkId === 80009) return "js/lecturer-support.js";
	if (chunkId === 81728) return "js/lecturer-elections.js";
	if (chunkId === 24845) return "js/lecturer-elections-vote.js";
	if (chunkId === 81531) return "js/lecturer-profile.js";
	if (chunkId === 28929) return "js/lecturer-add-assignment.js";
	if (chunkId === 67063) return "js/lectures-list.js";
	if (chunkId === 20422) return "js/lectures-meet.js";
	if (chunkId === 45287) return "js/lecturer-cbt-home.js";
	if (chunkId === 60026) return "js/lecturer-cbt-list.js";
	if (chunkId === 94587) return "js/lecturer-cbt-add.js";
	if (chunkId === 20721) return "js/lecturer-cbt-questions.js";
	if (chunkId === 13989) return "js/lecturer-timetable.js";
	if (chunkId === 96215) return "js/lecturer-learned-conferences.js";
	if (chunkId === 96004) return "js/lecturer-learned-conference.js";
	if (chunkId === 22785) return "js/lecturer-learned-conference-list.js";
	if (chunkId === 5705) return "js/lecturer-learned-conference-application.js";
	if (chunkId === 67211) return "js/support-staff-announcement.js";
	if (chunkId === 92611) return "js/support-staff-support.js";
	if (chunkId === 8989) return "js/support-staff-profile.js";
	if (chunkId === 6022) return "js/support-staff-elections.js";
	if (chunkId === 16839) return "js/support-staff-elections-vote.js";
	if (chunkId === 77007) return "js/admin-dashboard.js";
	if (chunkId === 34156) return "js/admin-overview.js";
	if (chunkId === 95529) return "js/institutes-home.js";
	if (chunkId === 81542) return "js/graduating-list.js";
	if (chunkId === 16250) return "js/super-admin-profile.js";
	if (chunkId === 61207) return "js/institution-profile.js";
	if (chunkId === 85085) return "js/institution-support.js";
	if (chunkId === 99774) return "js/institution-themes.js";
	if (chunkId === 79428) return "js/admin-learned-conferences.js";
	if (chunkId === 67153) return "js/all-learned-conferences-list.js";
	if (chunkId === 34744) return "js/admin-siwes.js";
	if (chunkId === 35819) return "js/users-student-profile.js";
	if (chunkId === 27730) return "js/users-student-status.js";
	if (chunkId === 89782) return "js/users-lecturer-profile.js";
	if (chunkId === 50732) return "js/sub-admins.js";
	if (chunkId === 40807) return "js/admin-clearance-management.js";
	if (chunkId === 21426) return "js/admin-clearance-certificates.js";
	if (chunkId === 6358) return "js/admin-clearance-list.js";
	if (chunkId === 42651) return "js/clearance-lists.js";
	if (chunkId === 99624) return "js/on-demand-clearance-clearance.js";
	if (chunkId === 24238) return "js/on-demand-clearance-list.js";
	if (chunkId === 90332) return "js/on-demand-clearance-details.js";
	if (chunkId === 76678) return "js/on-demand-clearance-students.js";
	if (chunkId === 43816) return "js/manage-campuses.js";
	if (chunkId === 58396) return "js/campus-lists.js";
	if (chunkId === 163) return "js/study-centre-list.js";
	if (chunkId === 34155) return "js/manage-affiliates.js";
	if (chunkId === 10607) return "js/faculty-departments.js";
	if (chunkId === 38601) return "js/faculty-lists.js";
	if (chunkId === 47918) return "js/department-list.js";
	if (chunkId === 30142) return "js/academic-unit-list.js";
	if (chunkId === 68382) return "js/directorates-and-units.js";
	if (chunkId === 21765) return "js/directorates-list.js";
	if (chunkId === 12436) return "js/service-unit-list.js";
	if (chunkId === 19761) return "js/faculty-profile.js";
	if (chunkId === 29737) return "js/department-profile.js";
	if (chunkId === 62361) return "js/academic-unit-profile.js";
	if (chunkId === 43744) return "js/institute-profile.js";
	if (chunkId === 82184) return "js/programmes-and-course-home.js";
	if (chunkId === 66948) return "js/mainstream-academic-programmes.js";
	if (chunkId === 26330) return "js/programme-specializations.js";
	if (chunkId === 42440) return "js/affiliate-academic-programmes.js";
	if (chunkId === 81113) return "js/courses-home.js";
	if (chunkId === 73290) return "js/managecourse-list.js";
	if (chunkId === 12729) return "js/admin-manage-course-specs.js";
	if (chunkId === 41944) return "js/manage-credit-load-limit-list.js";
	if (chunkId === 86089) return "js/'mode-of-study-home.js";
	if (chunkId === 61072) return "js/mode-of-study.js";
	if (chunkId === 16492) return "js/matric-no-template-home.js";
	if (chunkId === 59587) return "js/matric-template-list.js";
	if (chunkId === 64053) return "js/generate-matric-no.js";
	if (chunkId === 51354) return "js/matric-number-buffer.js";
	if (chunkId === 15428) return "js/matric-number-list.js";
	if (chunkId === 94220) return "js/students-registration-list-home.js";
	if (chunkId === 2728) return "js/students-registration-list.js";
	if (chunkId === 77241) return "js/students-registration-submission-list.js";
	if (chunkId === 86204) return "js/students-courses-enrollment-list.js";
	if (chunkId === 86653) return "js/students-courses-reg-management.js";
	if (chunkId === 80360) return "js/admin-students-course-registration-information.js";
	if (chunkId === 60327) return "js/manage-students-results-list.js";
	if (chunkId === 8559) return "js/admin-student-results.js";
	if (chunkId === 23626) return "js/semester-and-session-home.js";
	if (chunkId === 7713) return "js/academic-sessions-list.js";
	if (chunkId === 95945) return "js/semesters-list.js";
	if (chunkId === 65919) return "js/session-semester-setting.js";
	if (chunkId === 29835) return "js/late-registrations-list.js";
	if (chunkId === 90086) return "js/late-registration-exemption-list.js";
	if (chunkId === 36119) return "js/manage-announcement-list.js";
	if (chunkId === 53664) return "js/ranks-home.js";
	if (chunkId === 32689) return "js/academic-ranks-list.js";
	if (chunkId === 37875) return "js/non-academic-ranks-list.js";
	if (chunkId === 77385) return "js/rank-cadres-list.js";
	if (chunkId === 40496) return "js/academic-degree-categories.js";
	if (chunkId === 12106) return "js/academic-levels-home.js";
	if (chunkId === 96021) return "js/program-academic-levels.js";
	if (chunkId === 2936) return "js/student-academic-levels.js";
	if (chunkId === 73299) return "js/student-level-progression.js";
	if (chunkId === 53098) return "js/time-tables-home.js";
	if (chunkId === 53864) return "js/time-table-list.js";
	if (chunkId === 203) return "js/time-table-profiles-list.js";
	if (chunkId === 59129) return "js/lecture-venues-list.js";
	if (chunkId === 63467) return "js/time-table-editor.js";
	if (chunkId === 2887) return "js/time-table-activities-editor.js";
	if (chunkId === 61115) return "js/roles-permissions-home.js";
	if (chunkId === 43827) return "js/admin-transfer-requests.js";
	if (chunkId === 44132) return "js/admin-transfer-requests-list.js";
	if (chunkId === 93950) return "js/admin-transfer-request-all.js";
	if (chunkId === 90908) return "js/admin-transfer-request-release.js";
	if (chunkId === 67652) return "js/admin-transfer-request-acceptance.js";
	if (chunkId === 21908) return "js/admin-transfer-request-approval.js";
	if (chunkId === 6671) return "js/admin-candidate-recommendations.js";
	if (chunkId === 77744) return "js/admin-candidate-recommendations-list.js";
	if (chunkId === 77219) return "js/admin-extra-credit-applications.js";
	if (chunkId === 64116) return "js/admin-extra-credit-applications-list.js";
	if (chunkId === 83748) return "js/all-extra-credit-applications-list.js";
	if (chunkId === 98060) return "js/admin-scholarship-list.js";
	if (chunkId === 61094) return "js/grant-revoke permissions.js";
	if (chunkId === 60018) return "js/change-of-programme.js";
	if (chunkId === 18191) return "js/admin-graduation-management.js";
	if (chunkId === 30334) return "js/admin-graduation-list.js";
	if (chunkId === 80755) return "js/admin-graduated-students.js";
	if (chunkId === 82431) return "js/good-standing-management.js";
	if (chunkId === 63768) return "js/students-demography.js";
	if (chunkId === 69137) return "js/ticketing.js";
	if (chunkId === 85751) return "js/ticketing-home.js";
	if (chunkId === 25701) return "js/ticketing-lists.js";
	if (chunkId === 38809) return "js/department-staff-list.js";
	if (chunkId === 60107) return "js/departmental-programmes-list.js";
	if (chunkId === 38541) return "js/transfer-requests.js";
	if (chunkId === 84881) return "js/inbound-transfer-requests.js";
	if (chunkId === 69603) return "js/outbaound-transfer-requests.js";
	if (chunkId === 93123) return "js/departmental-courses.js";
	if (chunkId === 40867) return "js/departmental-course-allocation.js";
	if (chunkId === 1889) return "js/departmental-course-publication.js";
	if (chunkId === 64310) return "js/departmental-graduating-list.js";
	if (chunkId === 79322) return "js/departmental-academic-advisers.js";
	if (chunkId === 14723) return "js/departmental-appoint-exam-officer.js";
	if (chunkId === 2332) return "js/departmental-students-list.js";
	if (chunkId === 78347) return "js/departmental-students-results-list.js";
	if (chunkId === 81889) return "js/departmental-cummulative-results-list.js";
	if (chunkId === 72150) return "js/departmental-students-results.js";
	if (chunkId === 83703) return "js/departmental-course-result-list.js";
	if (chunkId === 21244) return "js/departmental-assessment-score.js";
	if (chunkId === 74364) return "js/departmental-students-registration-list-home.js";
	if (chunkId === 25961) return "js/departmental-students-registration-submission-list.js";
	if (chunkId === 10540) return "js/departmental-students-courses-enrollment-list.js";
	if (chunkId === 6689) return "js/departmental-course-registrations.js";
	if (chunkId === 23673) return "js/departmental-extra-credit-applications.js";
	if (chunkId === 74741) return "js/departmental-learned-conference-applications.js";
	if (chunkId === 61355) return "js/departmental-clearance-lists.js";
	if (chunkId === 71623) return "js/departmental-all-candidates.js";
	if (chunkId === 96740) return "js/request-email-verification-link.js";
	if (chunkId === 70579) return "js/department-progression.js";
	if (chunkId === 73044) return "js/departmental-graduation-list.js";
	if (chunkId === 99501) return "js/departmental-graduation-management.js";
	if (chunkId === 1933) return "js/departmental-graduated-students.js";
	if (chunkId === 20111) return "js/departmental-good-standing-management.js";
	if (chunkId === 47678) return "js/curriculum.js";
	if (chunkId === 65937) return "js/departmental-curriculum-dashboard.js";
	if (chunkId === 37691) return "js/all-curricula.js";
	if (chunkId === 20690) return "js/manage.js";
	if (chunkId === 80788) return "js/curriculum-allocations.js";
	if (chunkId === 27106) return "js/course-specialization.js";
	if (chunkId === 7485) return "js/course-groups.js";
	if (chunkId === 83848) return "js/course-durations.js";
	if (chunkId === 21036) return "js/graduation-requirements.js";
	if (chunkId === 76706) return "js/cordinator-curriculum.js";
	if (chunkId === 90021) return "js/cordinator-curriculum-dashboard.js";
	if (chunkId === 68943) return "js/cordinator-all-curricula.js";
	if (chunkId === 84702) return "js/cordinator-manage-curriculum.js";
	if (chunkId === 65440) return "js/cordinator-curriculum-allocations.js";
	if (chunkId === 31870) return "js/cordinator-course-specialization.js";
	if (chunkId === 30553) return "js/cordinator-course-groups.js";
	if (chunkId === 22012) return "js/cordinator-course-durations.js";
	if (chunkId === 17776) return "js/cordinator-graduation-requirements.js";
	if (chunkId === 32304) return "js/cordinator-staff-list.js";
	if (chunkId === 45519) return "js/cordinator-programmes-list.js";
	if (chunkId === 45593) return "js/cordinator-transfer-requests.js";
	if (chunkId === 56205) return "js/cordinator-inbound-transfer-requests.js";
	if (chunkId === 40793) return "js/cordinator-outbound-teransfer-requests.js";
	if (chunkId === 99388) return "js/cordinator-courses.js";
	if (chunkId === 23559) return "js/cordinator-course-allocation.js";
	if (chunkId === 27510) return "js/cordinator-academic-advisers.js";
	if (chunkId === 8199) return "js/cordinator-appoint-exam-officer.js";
	if (chunkId === 63992) return "js/cordinator-students-list.js";
	if (chunkId === 56143) return "js/cordinator-students-results-list.js";
	if (chunkId === 85210) return "js/cordinator-students-results.js";
	if (chunkId === 32104) return "js/cordinator-assessment-score.js";
	if (chunkId === 95205) return "js/cordinator-course-publication.js";
	if (chunkId === 62416) return "js/cordinator-students-registration-list-home.js";
	if (chunkId === 87109) return "js/cordinator-students-registration-submission-list.js";
	if (chunkId === 66048) return "js/cordinator-students-courses-enrollment-list.js";
	if (chunkId === 96637) return "js/cordinator-course-registrations.js";
	if (chunkId === 50686) return "js/cordinator-students-course-registration-documents.js";
	if (chunkId === 82469) return "js/cordinator-extra-credit-applications.js";
	if (chunkId === 56655) return "js/cordinator-course-specifications.js";
	if (chunkId === 41828) return "js/cordinator-progression.js";
	if (chunkId === 196) return "js/coordinator-graduation-management.js";
	if (chunkId === 40784) return "js/cordinator-graduation-list.js";
	if (chunkId === 71086) return "js/coordinator-graduated-students.js";
	if (chunkId === 16755) return "js/cordinator-good-standing-management.js";
	if (chunkId === 34802) return "js/director-courses.js";
	if (chunkId === 55846) return "js/director-course-allocation.js";
	if (chunkId === 23258) return "js/director-course-publication.js";
	if (chunkId === 73124) return "js/director-appoint-exam-officer.js";
	if (chunkId === 45171) return "js/director-assessment-score.js";
	if (chunkId === 90902) return "js/director-course-registrations.js";
	if (chunkId === 90280) return "js/director-good-standing-management.js";
	if (chunkId === 40664) return "js/institute-hostel.js";
	if (chunkId === 36619) return "js/institute-hostel-dashboard.js";
	if (chunkId === 956) return "js/institute-hostels-and-hostel-blocks.js";
	if (chunkId === 76955) return "js/institute-manage-hostels.js";
	if (chunkId === 47355) return "js/institute-hostel-blocks.js";
	if (chunkId === 95915) return "js/institute-hostel-block-allocation.js";
	if (chunkId === 50904) return "js/institute-hostel-rooms-and-bedspaces.js";
	if (chunkId === 52571) return "js/institute-manage-rooms.js";
	if (chunkId === 25618) return "js/institute-hostel-bed-spaces.js";
	if (chunkId === 50535) return "js/institute-bedspace-reservation-and-allocations.js";
	if (chunkId === 22881) return "js/institute-manage-bed-space-allocations.js";
	if (chunkId === 11026) return "js/institute-allocations.js";
	if (chunkId === 34481) return "js/institute-hostel-balloting-schedule.js";
	if (chunkId === 15904) return "js/institute-manual-hostel-reservation.js";
	if (chunkId === 38292) return "js/institute-manual-hostel-allocation.js";
	if (chunkId === 21443) return "js/academic-adviser-course-specification.js";
	if (chunkId === 58993) return "js/academic-adviser-students-list.js";
	if (chunkId === 99308) return "js/academic-adviser-students-course-registration.js";
	if (chunkId === 19461) return "js/academic-adviser-students-course-registration-documents.js";
	if (chunkId === 64819) return "js/academic-adviser-students-result-list.js";
	if (chunkId === 59358) return "js/academic-adviser-students-result.js";
	if (chunkId === 89678) return "js/academic-adviser-student-extra-credit-applications.js";
	if (chunkId === 93408) return "js/academic-adviser-good-standing-management.js";
	if (chunkId === 29369) return "js/academic-adviser-progression.js";
	if (chunkId === 63548) return "js/department-exam-officer-students-list.js";
	if (chunkId === 12075) return "js/department-exam-officer-students-results-list.js";
	if (chunkId === 32086) return "js/department-exam-officer-students-results.js";
	if (chunkId === 67523) return "js/department-exam-officer-courses.js";
	if (chunkId === 57025) return "js/department-exam-officer-course-registrations.js";
	if (chunkId === 67075) return "js/department-exam-officer-course-allocation.js";
	if (chunkId === 22964) return "js/department-exam-officer-staff-list.js";
	if (chunkId === 99100) return "js/department-exam-officer-students-registration-list-home.js";
	if (chunkId === 83945) return "js/department-exam-officer-students-registration-submission-list.js";
	if (chunkId === 61868) return "js/department-exam-officer-students-courses-enrollment-list.js";
	if (chunkId === 83120) return "js/faculty-departments-list.js";
	if (chunkId === 76593) return "js/faculty-staff-list.js";
	if (chunkId === 25250) return "js/faculty-hods.js";
	if (chunkId === 4013) return "js/faculty-academic-advisers.js";
	if (chunkId === 27411) return "js/faculty-students-list.js";
	if (chunkId === 64815) return "js/faculty-students-results.js";
	if (chunkId === 20204) return "js/faculty-students-result.js";
	if (chunkId === 93880) return "js/faculty-programmes-list.js";
	if (chunkId === 53304) return "js/faculty-courses.js";
	if (chunkId === 79816) return "js/faculty-course-registrations.js";
	if (chunkId === 33958) return "js/faculty-extra-credit-applications.js";
	if (chunkId === 41678) return "js/faculty-learned-conference-applications.js";
	if (chunkId === 16940) return "js/faculty-clearance-lists.js";
	if (chunkId === 20438) return "js/faculty-all-candidates.js";
	if (chunkId === 18986) return "js/faculty-course-result-list.js";
	if (chunkId === 98131) return "js/faculty-students-registration-list-home.js";
	if (chunkId === 13538) return "js/faculty-students-registration-submission-list.js";
	if (chunkId === 22577) return "js/faculty-students-courses-enrollment-list.js";
	if (chunkId === 17390) return "js/faculty-appoint-exam-officer.js";
	if (chunkId === 55140) return "js/departments-overview.js";
	if (chunkId === 99191) return "js/department-overview.js";
	if (chunkId === 97410) return "js/selected-department-staff.js";
	if (chunkId === 49992) return "js/selected-department-students.js";
	if (chunkId === 76225) return "js/selected-department-programmes.js";
	if (chunkId === 28590) return "js/selected-department-courses.js";
	if (chunkId === 49450) return "js/faculty-graduation-management.js";
	if (chunkId === 86715) return "js/faculty-graduation-list.js";
	if (chunkId === 94600) return "js/faculty-graduated-students.js";
	if (chunkId === 64326) return "js/faculty-good-standing-management.js";
	if (chunkId === 36985) return "js/faculty-exam-officer-departments-list.js";
	if (chunkId === 66547) return "js/faculty-exam-officer-programmes-list.js";
	if (chunkId === 82507) return "js/faculty-exam-officer-course-allocation.js";
	if (chunkId === 83100) return "js/faculty-exam-officer-staff-list.js";
	if (chunkId === 63975) return "js/faculty-exam-officer-hods.js";
	if (chunkId === 60868) return "js/faculty-exam-officer-students-list.js";
	if (chunkId === 47454) return "js/faculty-exam-officer-students-results.js";
	if (chunkId === 42023) return "js/faculty-exam-officer-students-result.js";
	if (chunkId === 63355) return "js/faculty-exam-officer-courses.js";
	if (chunkId === 39769) return "js/faculty-exam-officer-course-registrations.js";
	if (chunkId === 77940) return "js/faculty-exam-officer-students-registration-list-home.js";
	if (chunkId === 57857) return "js/faculty-exam-officer-students-registration-submission-list.js";
	if (chunkId === 6004) return "js/faculty-exam-officer-students-courses-enrollment-list.js";
	if (chunkId === 71473) return "js/administrative-officer-clearance-lists.js";
	if (chunkId === 84223) return "js/finance-officer-clearance-lists.js";
	if (chunkId === 63293) return "js/hostel-manager-clearance-lists.js";
	if (chunkId === 83715) return "js/institutes.js";
	if (chunkId === 76140) return "js/institute-home.js";
	if (chunkId === 62479) return "js/institute-extra-credit-applications.js";
	if (chunkId === 74736) return "js/institute-extra-credit-applications-list.js";
	if (chunkId === 13570) return "js/institute-all-extra-credit-applications-list.js";
	if (chunkId === 6738) return "js/institutes-manage-course-specs.js";
	if (chunkId === 66639) return "js/users-home.js";
	if (chunkId === 68832) return "js/institute-users-students.js";
	if (chunkId === 71459) return "js/institute-users-lecturers.js";
	if (chunkId === 49126) return "js/institute-users-supporting-staff.js";
	if (chunkId === 75601) return "js/institute-roles-permissions-home.js";
	if (chunkId === 57265) return "js/institutes-units.js";
	if (chunkId === 57535) return "js/institute-unit-profile.js";
	if (chunkId === 46277) return "js/institutes-deputy-directors.js";
	if (chunkId === 13835) return "js/institutes-academic-degree-categories.js";
	if (chunkId === 21404) return "js/institute-graduating-list.js";
	if (chunkId === 26941) return "js/institute-good-standing-management.js";
	if (chunkId === 28917) return "js/institutes-academic-levels-home.js";
	if (chunkId === 74632) return "js/institutes-program-academic-levels.js";
	if (chunkId === 34001) return "js/institutes-student-academic-levels.js";
	if (chunkId === 90006) return "js/institutes-student-level-progression.js";
	if (chunkId === 23212) return "js/institutes-manage-announcement-list.js";
	if (chunkId === 31253) return "js/institutes-matric-no-template-home.js";
	if (chunkId === 68292) return "js/institutes-matric-template-list.js";
	if (chunkId === 43286) return "js/institutes-generate-matric-no.js";
	if (chunkId === 1817) return "js/institutes-matric-number-buffer.js";
	if (chunkId === 9387) return "js/institutes-matric-number-list.js";
	if (chunkId === 99157) return "js/institutes-students-registration-list-home.js";
	if (chunkId === 61399) return "js/institutes-students-registration-list.js";
	if (chunkId === 93648) return "js/institutes-students-registration-submission-list.js";
	if (chunkId === 76343) return "js/institutes-students-courses-enrollment-list.js";
	if (chunkId === 83988) return "js/institutes-graduation-management.js";
	if (chunkId === 9757) return "js/institutes-graduation-list.js";
	if (chunkId === 98302) return "js/institutes-graduated-students.js";
	if (chunkId === 14644) return "js/institute-user.js";
	if (chunkId === 57328) return "js/institute-user-home.js";
	if (chunkId === 6971) return "js/institute-all-students.js";
	if (chunkId === 35250) return "js/institute-students-data.js";
	if (chunkId === 87635) return "js/institute-grading-system.js";
	if (chunkId === 34229) return "js/institute-grading-home.js";
	if (chunkId === 63877) return "js/institute-grade-profiles.js";
	if (chunkId === 57420) return "js/institute-grade-profiles-allocation.js";
	if (chunkId === 68354) return "js/institute-grade-lists.js";
	if (chunkId === 54750) return "js/institute-assessment-score.js";
	if (chunkId === 53559) return "js/institute-course-publication.js";
	if (chunkId === 13940) return "js/institute-grade-point-average-profiles.js";
	if (chunkId === 72702) return "js/institute-degree-class.js";
	if (chunkId === 37584) return "js/institute-gpa-profile-allocation-home.js";
	if (chunkId === 34644) return "js/institute-default-gpa-profile-allocation.js";
	if (chunkId === 91027) return "js/institute-sessional-grade-point-average-profiles-allocation.js";
	if (chunkId === 6199) return "js/institute-admissions.js";
	if (chunkId === 54869) return "js/institute-admissions-home.js";
	if (chunkId === 85948) return "js/institute-candidates-list.js";
	if (chunkId === 16893) return "js/institute-modes-and-catchments-list.js";
	if (chunkId === 9057) return "js/institute-modes-of-entry-list.js";
	if (chunkId === 56736) return "js/institute-cathcment-states-list.js";
	if (chunkId === 22750) return "js/institute-exam-bodies-and-type.js";
	if (chunkId === 5946) return "js/institute-exam-bodies-list.js";
	if (chunkId === 78789) return "js/institute-exam-types-list.js";
	if (chunkId === 50391) return "js/institute-exam-cities-and-centres.js";
	if (chunkId === 61567) return "js/institute-post-utme-exams-list.js";
	if (chunkId === 25781) return "js/institute-exam-cities-list.js";
	if (chunkId === 9612) return "js/institute-exam-centres-list.js";
	if (chunkId === 1949) return "js/institute-post-utme-exam-batches-list.js";
	if (chunkId === 20860) return "js/institute-post-utme-exam-batch.js";
	if (chunkId === 69034) return "js/institute-post-utme-exam-allocations-list.js";
	if (chunkId === 72383) return "js/institute-candidate-approvals.js";
	if (chunkId === 90304) return "js/institute-candidate-approvals-list.js";
	if (chunkId === 26870) return "js/institute-all-candidate-approvals-list.js";
	if (chunkId === 98360) return "js/institute-admissions-list.js";
	if (chunkId === 76956) return "js/institute-olevel-grades-list.js";
	if (chunkId === 11272) return "js/alevel-grades-list.js";
	if (chunkId === 17981) return "js/degree-grades-list.js";
	if (chunkId === 31528) return "js/institute-admission-acceptance-deadlines.js";
	if (chunkId === 13460) return "js/institute-admissions-rounds-list.js";
	if (chunkId === 52072) return "js/institute-past-papers-list.js";
	if (chunkId === 20591) return "js/institute-advertised-programmes-units-list.js";
	if (chunkId === 80017) return "js/institute-advertised-programmes-list.js";
	if (chunkId === 33994) return "js/institute-admissions-clearance-unit-list.js";
	if (chunkId === 51333) return "js/institute-admission-clearance.js";
	if (chunkId === 29958) return "js/institute-institutional-general-admission-requirements.js";
	if (chunkId === 52362) return "js/institute-programme-admission-requirements.js";
	if (chunkId === 76181) return "js/institute-programme-candidates-list.js";
	if (chunkId === 77597) return "js/institute-clearance-candidates-list.js";
	if (chunkId === 25383) return "js/institute-candidates-application-details.js";
	if (chunkId === 6642) return "js/institute-candidates-application-clearance-details.js";
	if (chunkId === 35751) return "js/finance.js";
	if (chunkId === 81925) return "js/finance-home.js";
	if (chunkId === 84206) return "js/payments-lists.js";
	if (chunkId === 95444) return "js/institute-admission-processing-charges.js";
	if (chunkId === 84052) return "js/institute-convocation-charges.js";
	if (chunkId === 70206) return "js/institute-invoice-management.js";
	if (chunkId === 70534) return "js/institute-invoice-lists.js";
	if (chunkId === 54950) return "js/institute-invoice-gateways.js";
	if (chunkId === 38912) return "js/fees.js";
	if (chunkId === 16560) return "js/institute-fee-plans.js";
	if (chunkId === 1872) return "js/institute-fee-plan-allocation.js";
	if (chunkId === 90061) return "js/institute-rebates-home.js";
	if (chunkId === 95583) return "js/institute-rebates.js";
	if (chunkId === 61722) return "js/institute-rebates-grant.js";
	if (chunkId === 84278) return "js/institute-scholarships.js";
	if (chunkId === 89962) return "js/institute-scholarship-grant.js";
	if (chunkId === 53890) return "js/institute-fee-plan-items.js";
	if (chunkId === 55772) return "js/institute-bank-accounts.js";
	if (chunkId === 66357) return "js/institute-transaction-validation.js";
	if (chunkId === 51162) return "js/supplementary-fee-allocation.js";
	if (chunkId === 12533) return "js/insitute-hostel-pool-charges.js";
	if (chunkId === 10840) return "js/institute-supplementary-fee-details.js";
	if (chunkId === 15666) return "js/institute-admin-curriculum.js";
	if (chunkId === 44687) return "js/institute-curriculum-dashboard.js";
	if (chunkId === 84704) return "js/institute-curriculum-management.js";
	if (chunkId === 6301) return "js/institute-curriculums-allocations.js";
	if (chunkId === 76797) return "js/grading-system.js";
	if (chunkId === 73139) return "js/grading-home.js";
	if (chunkId === 55714) return "js/grade-profiles-allocation.js";
	if (chunkId === 79616) return "js/grade-lists.js";
	if (chunkId === 59168) return "js/grade-profile-exception-lists.js";
	if (chunkId === 46216) return "js/assessment-policy.js";
	if (chunkId === 45324) return "js/assessment-score.js";
	if (chunkId === 82625) return "js/admin-add-assessment.js";
	if (chunkId === 54737) return "js/course-publication.js";
	if (chunkId === 32522) return "js/grade-point-average-profiles.js";
	if (chunkId === 51436) return "js/grade-lock.js";
	if (chunkId === 35892) return "js/students-result-list-home.js";
	if (chunkId === 61568) return "js/students-result-list.js";
	if (chunkId === 75806) return "js/cummulative-result-list.js";
	if (chunkId === 94524) return "js/spreadsheet-list.js";
	if (chunkId === 6078) return "js/results-spreadsheet.js";
	if (chunkId === 27404) return "js/degree-class.js";
	if (chunkId === 1226) return "js/gpa-profile-allocation-home.js";
	if (chunkId === 26530) return "js/default-gpa-profile-allocation.js";
	if (chunkId === 21489) return "js/sessional-grade-point-average-profiles-allocation.js";
	if (chunkId === 57608) return "js/grade-profile-home.js";
	if (chunkId === 35711) return "js/grade-profiles.js";
	if (chunkId === 97981) return "js/special-grade-profiles.js";
	if (chunkId === 18855) return "js/course-result-list.js";
	if (chunkId === 49394) return "js/lecturer-assessment.js";
	if (chunkId === 89718) return "js/lecturer-assessment-home.js";
	if (chunkId === 60833) return "js/lecturer-assessment-add-question.js";
	if (chunkId === 68475) return "js/lecturer-assessment-questionnaire-question.js";
	if (chunkId === 28402) return "js/lecturer-assessment-questionnaire.js";
	if (chunkId === 94585) return "js/lecturer-assessment-questionnaire-allocation.js";
	if (chunkId === 75022) return "js/lecturer-assessment-questionnaire-response.js";
	if (chunkId === 14976) return "js/programme-requirements.js";
	if (chunkId === 49965) return "js/admissions.js";
	if (chunkId === 98779) return "js/admissions-home.js";
	if (chunkId === 87322) return "js/candidates-list.js";
	if (chunkId === 99299) return "js/modes-and-catchments-list.js";
	if (chunkId === 30131) return "js/modes-of-entry-list.js";
	if (chunkId === 65462) return "js/cathcment-states-list.js";
	if (chunkId === 88400) return "js/exam-bodies-and-type.js";
	if (chunkId === 9444) return "js/exam-bodies-list.js";
	if (chunkId === 65163) return "js/exam-types-list.js";
	if (chunkId === 45321) return "js/exam-cities-and-centres.js";
	if (chunkId === 43753) return "js/post-utme-exams-list.js";
	if (chunkId === 24467) return "js/exam-cities-list.js";
	if (chunkId === 26302) return "js/exam-centres-list.js";
	if (chunkId === 43707) return "js/post-utme-exam-batches-list.js";
	if (chunkId === 1926) return "js/post-utme-exam-batch.js";
	if (chunkId === 73416) return "js/post-utme-exam-allocations-list.js";
	if (chunkId === 19662) return "js/olevel-grades-list.js";
	if (chunkId === 37594) return "js/admission-acceptance-deadlines.js";
	if (chunkId === 92894) return "js/admissions-rounds-list.js";
	if (chunkId === 9018) return "js/advertised-programmes-faculties-list.js";
	if (chunkId === 79775) return "js/advertised-programmes-list.js";
	if (chunkId === 1204) return "js/admissions-clearance-faculties-list.js";
	if (chunkId === 48891) return "js/admission-clearance.js";
	if (chunkId === 90172) return "js/movement-home.js";
	if (chunkId === 55589) return "js/movement-list.js";
	if (chunkId === 44365) return "js/to-be-moved-list.js";
	if (chunkId === 40403) return "js/pending-movement-list.js";
	if (chunkId === 78090) return "js/admission-agents-list.js";
	if (chunkId === 69524) return "js/institutional-general-admission-requirements.js";
	if (chunkId === 76651) return "js/programme-candidates-list.js";
	if (chunkId === 30555) return "js/clearance-candidates-list.js";
	if (chunkId === 46429) return "js/candidates-application-details.js";
	if (chunkId === 79608) return "js/candidates-application-clearance-details.js";
	if (chunkId === 81299) return "js/admin-candidate-approvals.js";
	if (chunkId === 26596) return "js/admin-candidate-approvals-list.js";
	if (chunkId === 48546) return "js/admin-all-candidate-approvals-list.js";
	if (chunkId === 3004) return "js/admin-admissions-list.js";
	if (chunkId === 30982) return "js/admissions-list.js";
	if (chunkId === 24098) return "js/election-management.js";
	if (chunkId === 28417) return "js/election-dashboard.js";
	if (chunkId === 66152) return "js/e-voting.js";
	if (chunkId === 13974) return "js/student-e-voting.js";
	if (chunkId === 37819) return "js/staff-e-voting.js";
	if (chunkId === 33585) return "js/elective-positions.js";
	if (chunkId === 50963) return "js/elective-position-contestants.js";
	if (chunkId === 63560) return "js/electorates.js";
	if (chunkId === 48262) return "js/elective-position-votes.js";
	if (chunkId === 96806) return "js/user.js";
	if (chunkId === 87362) return "js/user-home.js";
	if (chunkId === 81913) return "js/users-management-home.js";
	if (chunkId === 59322) return "js/users-students.js";
	if (chunkId === 31981) return "js/users-lecturers.js";
	if (chunkId === 21756) return "js/users-supporting-staff.js";
	if (chunkId === 83057) return "js/all-students.js";
	if (chunkId === 46764) return "js/students-data.js";
	if (chunkId === 56243) return "js/users-students-results.js";
	if (chunkId === 81402) return "js/admission-processing-charges.js";
	if (chunkId === 134) return "js/manage-fee-items.js";
	if (chunkId === 28466) return "js/fee-items.js";
	if (chunkId === 10079) return "js/fee-heads.js";
	if (chunkId === 31655) return "js/fee-item-groupss.js";
	if (chunkId === 65858) return "js/fee-plans.js";
	if (chunkId === 82742) return "js/fee-plan-allocation.js";
	if (chunkId === 25278) return "js/suplimentaty-fees.js";
	if (chunkId === 66576) return "js/suplimentary-fees.js";
	if (chunkId === 98902) return "js/supplimentary-fee-allocation.js";
	if (chunkId === 8479) return "js/rebates-home.js";
	if (chunkId === 58409) return "js/rebates.js";
	if (chunkId === 91800) return "js/rebates-grant.js";
	if (chunkId === 74488) return "js/scholarships.js";
	if (chunkId === 44192) return "js/scholarship-grant.js";
	if (chunkId === 96808) return "js/fee-plan-items.js";
	if (chunkId === 706) return "js/supplementary-fee-details.js";
	if (chunkId === 78754) return "js/bank-accounts.js";
	if (chunkId === 41733) return "js/hostel-pool-charges.js";
	if (chunkId === 18282) return "js/change-programme-charges.js";
	if (chunkId === 61922) return "js/convocation-charges.js";
	if (chunkId === 16708) return "js/invoice-management.js";
	if (chunkId === 65324) return "js/invoice-lists.js";
	if (chunkId === 87484) return "js/invoice-gateways.js";
	if (chunkId === 80392) return "js/service-charges.js";
	if (chunkId === 30666) return "js/candidate-admission-processing-charges.js";
	if (chunkId === 45960) return "js/private-candidate-admission-processing-charges.js";
	if (chunkId === 26689) return "js/candidate-dashboard.js";
	if (chunkId === 62987) return "js/admission-application.js";
	if (chunkId === 65431) return "js/utme-application.js";
	if (chunkId === 50417) return "js/candidate-announcements.js";
	if (chunkId === 77762) return "js/clearance-documents.js";
	if (chunkId === 58963) return "js/candidate-biodata.js";
	if (chunkId === 81575) return "js/candidate-olevels.js";
	if (chunkId === 27177) return "js/candidate-admission-status.js";
	if (chunkId === 58921) return "js/pay-admission-acceptance-fees.js";
	if (chunkId === 73374) return "js/admission-application-printouts.js";
	if (chunkId === 39378) return "js/migrate-candidate-to-student.js";
	if (chunkId === 49649) return "js/page-not-found.js";
	if (chunkId === 10002) return "js/hostel.js";
	if (chunkId === 59669) return "js/hostel-dashboard.js";
	if (chunkId === 90582) return "js/hostels-and-hostel-blocks.js";
	if (chunkId === 36329) return "js/manage-hostels.js";
	if (chunkId === 5725) return "js/hostel-blocks.js";
	if (chunkId === 81657) return "js/hostel-block-allocation.js";
	if (chunkId === 82630) return "js/hostel-rooms-and-bedspaces.js";
	if (chunkId === 197) return "js/manage-rooms.js";
	if (chunkId === 16576) return "js/hostel-bed-spaces.js";
	if (chunkId === 80285) return "js/bedspace-reservation-and-allocations.js";
	if (chunkId === 77195) return "js/manage-bed-space-allocations.js";
	if (chunkId === 56132) return "js/allocations.js";
	if (chunkId === 43175) return "js/hostel-balloting-schedule.js";
	if (chunkId === 23666) return "js/manual-hostel-reservation.js";
	if (chunkId === 6330) return "js/manual-hostel-allocation.js";
	if (chunkId === 50692) return "js/switch-role.js";
	if (chunkId === 23930) return "js/ug-applicant-login.js";
	if (chunkId === 89061) return "js/ug-inter-university-transfer.js";
	if (chunkId === 3602) return "js/ug-inter-university-transfer-enrollment.js";
	if (chunkId === 3360) return "js/ug-international-admission.js";
	if (chunkId === 32117) return "js/ug-international-admission-enrollment.js";
	if (chunkId === 46539) return "js/ug-applicant-enrollment.js";
	if (chunkId === 16308) return "js/applicant-email-verification.js";
	if (chunkId === 13631) return "js/direct-candidate-dashboard.js";
	if (chunkId === 78689) return "js/direct-candidate-application.js";
	if (chunkId === 64328) return "js/admin-curriculum.js";
	if (chunkId === 14081) return "js/curriculum-dashboard.js";
	if (chunkId === 4994) return "js/curriculum-management.js";
	if (chunkId === 40819) return "js/curriculums-allocations.js";
	// return url for filenames based on template
	return undefined;
};